// Custom global scripts
jQuery(document).ready(function($) {
    'use strict';

    // Foundation Init
    $(document).foundation();

    // Mobile nav toggle
    $('#nav-mobile-toggle').on('click', function() {
        $('#nav-mobile').slideToggle();
    });

    // Nav - position fixed
    if ($('.js--nav-fixed').length) {
	    var waypoint = new Waypoint({
		  	element: document.querySelector('.js--nav-fixed'),
		  	handler: function() {
		    	$('.site-header').toggleClass('site-header--fixed');
		    	$('.nav-main-wrap').toggleClass('nav-main-wrap--fixed');
		    	$('.logo').toggleClass('logo--fixed');
		  	}
		})
    } else {
    	var waypoint = new Waypoint({
    		element: document.querySelector('.site-header'),
    		handler: function(direction) {
    			$('.site-header').toggleClass('site-header--fixed');
		    	$('.nav-main-wrap').toggleClass('nav-main-wrap--fixed');
		    	$('.logo').toggleClass('logo--fixed');
    		},
    		offset: -600
    	});
    }

    // Sign Up Footer - Disclosure
    $('.js--ctct-disclosure').on('click', function() {
        $('.js--ctct-disclosure-content').slideToggle();
    })

}(jQuery));

import slick from 'slick-carousel-browserify';
